import { render, staticRenderFns } from "./maincharts.vue?vue&type=template&id=1672f9e0&scoped=true&"
import script from "./maincharts.vue?vue&type=script&lang=js&"
export * from "./maincharts.vue?vue&type=script&lang=js&"
import style0 from "./maincharts.vue?vue&type=style&index=0&id=1672f9e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1672f9e0",
  null
  
)

export default component.exports